import $ from 'jquery';

$(document).ready(function () {
  standardTextBlock();
});
function standardTextBlock() {
  $('.js-acf-standard-text-block').each(function () {});
}
